import React from "react"
import PropTypes from "prop-types"

import { InputCell } from "app/static/frontend/sheets/components/cells/MantineCells/InputCell"
import Tooltip from "app/static/frontend/components/Tooltip"
import sheetConstants from "app/static/frontend/sheets/constants"
import { calculateTextWidth } from "app/static/frontend/imports/styleHelperFunctions"
import { calculateHoverTextPosition } from "app/static/frontend/sheets/helper-functions"
import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"

const TOOLTIP_SHOW_FUDGE_FACTOR = 1.3

export interface DefaultCellProps {
    columnCount?: number
    columnIndex?: any
    cellIsEditable?: boolean
    cellValueIsNotEditable?: boolean
    delayShow?: any
    editing?: any
    isEditable?: boolean
    label?: string
    width?: number
    children?: any
    hasOptionalDisplayFunction?: boolean
    row?: any
}

/**
 * the default cell that is returned if no other cell type is specified
 * Supports editing the cell contents
 */
export const DefaultCell = ({
    columnCount,
    columnIndex,
    cellIsEditable,
    cellValueIsNotEditable,
    delayShow,
    editing,
    isEditable,
    label,
    width,
    children,
    hasOptionalDisplayFunction,
    row,
    ...props
}: DefaultCellProps) => {
    const renderDefaultCellWithToolTip = (calculatedPosition) => (
        <CellWrapper {...props}>
            <Tooltip delayShow={delayShow} label={children} placement={calculatedPosition}>
                <div>{!cellIsEditable && cellValueIsNotEditable ? "" : children}</div>
            </Tooltip>
        </CellWrapper>
    )

    const renderDefaultCell = () => (
        <CellWrapper {...props}>{!cellIsEditable && cellValueIsNotEditable ? "" : children}</CellWrapper>
    )

    if (editing && isEditable && !hasOptionalDisplayFunction && cellIsEditable) {
        return (
            <InputCell
                columnCount={columnCount}
                columnIndex={columnIndex}
                delayShow={delayShow}
                editing={editing}
                isEditable={isEditable}
                label={label}
                width={width}
                children={children}
                row={row}
                hasOptionalDisplayFunction={hasOptionalDisplayFunction}
                {...props}
            />
        )
    }

    if (calculateTextWidth(sheetConstants.columnNameFont, children) * TOOLTIP_SHOW_FUDGE_FACTOR > width) {
        return renderDefaultCellWithToolTip(calculateHoverTextPosition(columnCount, columnIndex))
    } else {
        return renderDefaultCell()
    }
}

DefaultCell.propTypes = {
    columnCount: PropTypes.number.isRequired,
    columnIndex: PropTypes.number.isRequired,
    delayShow: PropTypes.number,
    editing: PropTypes.bool.isRequired,
    isEditable: PropTypes.bool,
    label: PropTypes.string,
    placement: PropTypes.string,
    width: PropTypes.number.isRequired,
    hasOptionalDisplayFunction: PropTypes.bool,
}

DefaultCell.defaultProps = {
    delayShow: sheetConstants.CELL_TOOLTIP_DELAY,
    // keep for backwards compatibility. Eventually should be switched
    // when redoing Sheet.jsx and columnIsEditable
    isEditable: true,
    placement: "left",
}
